module.exports = require("node:url");